import { render, staticRenderFns } from "./companyinvoice.vue?vue&type=template&id=44d048db&"
import script from "./companyinvoice.vue?vue&type=script&lang=js&"
export * from "./companyinvoice.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports